import { LoadingStatusType, Locales } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/Index";
import { accountModal } from "@/model/type";
import { FilterAccountOfTransaction } from "@/helper/accountHelper";
import facade from "@/service/account/accountFacade";
import { i18n } from "@/i18n";

@Module({ namespaced: true })
export default class Account extends VuexModule {
  public accountList: Array<accountModal> = [];
  public accountListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  @Mutation
  public MutationAccountList(accountList: Array<accountModal>) {
    this.accountList = accountList;
    this.accountListLoadingStatus = LoadingStatusType.Success;
  }

  @Mutation
  public SetAccountListLoadingStatus(status: LoadingStatusType) {
    this.accountListLoadingStatus = LoadingStatusType.Loading;
  }

  @Action
  public DoGetAllMainAccount() {
    if (this.accountListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoGetAllMainAccount().then((resAllMainAccount) => {
        if (resAllMainAccount.data.responseCode.IsSuccess()) {
          const accountList = facade.ToAccountList(resAllMainAccount.data.accountList, i18n.locale as Locales);
          this.context.commit("MutationAccountList", accountList);
        } else {
          this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  get getAllAccountList(): Array<accountModal> {
    return this.accountList;
  }

  get getAccountList(): Array<accountModal> {
    return FilterAccountOfTransaction(this.accountList);
  }
  get getAccountListLoadingStatus(): LoadingStatusType {
    return this.accountListLoadingStatus;
  }
}
